@if (orderDetails$ | async; as orderDetails) {
  <div class="cart-summary border-radius">
    <div class="heading heading_standard heading_centered">Order Summary</div>
    <div class="cart-summary__block">
      @for (item of orderDetails.items; track item.id) {
        <div class="cart-summary__line">
          <div>
            <strong>{{ item.name }}</strong>
            <span>{{ item.description }}</span>
          </div>
          <div>
            <strong>{{ item.price | price }}</strong>
          </div>
          <span
            class="cursor-pointer cart-summary__remove"
            (click)="onRemove(item.id)"
          >
            <img
              src="assets/icon-close.svg"
              width="24"
              height="24"
              alt="Close icon"
            />
          </span>
        </div>
      }
    </div>
    @let totalPrice = sum(orderDetails);
    <div class="cart-summary__block">
      <div class="cart-summary__line">
        <div>Subtotal</div>
        <div>
          <strong>{{ totalPrice | price }}</strong>
        </div>
      </div>
      <div class="cart-summary__line">
        <div>VAT</div>
        <div>
          <strong>{{ orderDetails.total_amount - totalPrice | price }}</strong>
        </div>
      </div>
      <i> The VAT is calculated based on your account type and country. </i>
    </div>
    <div class="cart-summary__block cart-summary__block_main">
      <div class="cart-summary__line top">
        <div class="mtop16">Promo code</div>
        <div>
          <div
            class="fields__item fields__item_half"
            [appIfInvalid]="promocodeFC"
            [validationErrors]="{
              wrong: 'Promo code is invalid',
            }"
          >
            <input
              class="h40"
              [formControl]="promocodeFC"
              type="text"
              placeholder=""
              id="promo_code"
            />
            <ng-template [appErrorsHost] />
          </div>
        </div>
      </div>
      <div class="cart-summary__line">
        <div>Total amount</div>
        <div>{{ orderDetails.total_amount | price }}</div>
      </div>
    </div>
    @if (isAuthenticated$ | async) {
      <label>
        <input type="checkbox" #terms (change)="termsChecked = terms.checked" />
        I agree with
        <a href="/terms-of-use" target="_blank">Term & Service</a>
      </label>
      <button
        [disabled]="!termsChecked"
        type="submit"
        class="button button_dark button_large button_centered"
      >
        Purchase now
      </button>
    }
  </div>
}
